import { callAuthorizedGraphQLEndpoint } from '../../../../Module/graphQL'

export default async (campaignId, useReplicaDB = false) => {
  const query = `query ($campaignId:ID!, $useReplicaDB:Boolean) {
      campaign(id:$campaignId){
        cityPlans {
          nodes {
            id
            city {
                name
                lunchCheckInTime
                afternoonCheckInTime
                h2hCheckInTimeBefore
                h2hCheckInTimeAfter
                h2hBonusCheckInTimeBefore
                h2hBonusCheckInTimeAfter
                d2dCheckInTimeBefore
                d2dCheckInTimeAfter
                d2dBonusCheckInTimeBefore
                d2dBonusCheckInTimeAfter
                timezone                
            }
            missions(useReplicaDB:$useReplicaDB) {
                edges {
                    node {
                        id
                        status
                        isReadyToPublish
                        cancelled
                        dateTime
                    }
                }
                totalCount
            }
            }
        }
    }
}`

  const response = await callAuthorizedGraphQLEndpoint(query, {
    campaignId,
    useReplicaDB,
  })
  return response.json()
}
